var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.412,
    height: 23.387,
    viewBox: "0 0 23.412 23.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.417 3785.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-326.417 -3785.081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.412,231.847a.418.418,0,0,1-.418.418H.418A.418.418,0,0,1,0,231.847V219.3a.418.418,0,0,1,.418-.418h.836a.418.418,0,0,1,.418.418v10.034a1.258,1.258,0,0,0,1.254,1.254H20.485a1.258,1.258,0,0,0,1.254-1.254V219.3a.418.418,0,0,1,.418-.418h.836a.418.418,0,0,1,.418.418Zm0,0",
    transform: "translate(0 -208.878)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,222.679a.538.538,0,0,1-.533.542h-3.2a.538.538,0,0,1-.533-.542v-3.251a.538.538,0,0,1,.533-.542h3.2a.538.538,0,0,1,.533.542Zm0,0",
    transform: "translate(-331.401 -208.878)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,222.679a.538.538,0,0,1-.533.542h-3.2a.538.538,0,0,1-.533-.542v-3.251a.538.538,0,0,1,.533-.542h3.2a.538.538,0,0,1,.533.542Zm0,0",
    transform: "translate(-344.18 -208.878)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,222.679a.538.538,0,0,1-.533.542h-3.2a.538.538,0,0,1-.533-.542v-3.251a.538.538,0,0,1,.533-.542h3.2a.538.538,0,0,1,.533.542Zm0,0",
    transform: "translate(-344.18 -202.189)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,222.679a.538.538,0,0,1-.533.542h-3.2a.538.538,0,0,1-.533-.542v-3.251a.538.538,0,0,1,.533-.542h3.2a.538.538,0,0,1,.533.542Zm0,0",
    transform: "translate(-337.598 -202.189)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.7,222.679a.538.538,0,0,1-.533.542h-3.2a.538.538,0,0,1-.533-.542v-3.251a.538.538,0,0,1,.533-.542h3.2a.538.538,0,0,1,.533.542Zm0,0",
    transform: "translate(-331.401 -202.189)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.015,7.241a.4.4,0,0,1,.092-.452l1.426-1.426a.421.421,0,0,0,0-.594L82.949,2.187a.418.418,0,0,1,0-.589L84.425.122a.418.418,0,0,1,.589,0L87.6,2.705a.421.421,0,0,0,.594,0L89.617,1.28a.4.4,0,0,1,.452-.092.411.411,0,0,1,.259.389V7.082a.418.418,0,0,1-.418.418H84.4A.412.412,0,0,1,84.015,7.241Zm0,0",
    transform: "translate(-79.04 0)",
    fill: "#697384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.528,100.031a.418.418,0,0,0-.418.418v.836h-.836a.418.418,0,1,0,0,.836h.836a.836.836,0,0,0,.836-.836v-.836A.418.418,0,0,0,184.528,100.031Zm0,0",
    transform: "translate(-174.494 -95.457)",
    fill: "#697384"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.e4be27eeb682c2202839112255fbf73f.svg";
export { ForwardRef as ReactComponent };